export enum ListTypeEnum {
  up = 1, // 飙升榜
  sale = 2, // 销量榜
  news = 3, // 新品榜
}

// export const ListTypeArr = [ListTypeEnum.up, ListTypeEnum.sale, ListTypeEnum.news]

export enum ListTypeNameEnum {
  up = 'up', // 飙升榜
  sale = 'sale', // 销量榜
  news = 'news', // 新品榜
}

export const ListTypeMap = {
  [ListTypeEnum.sale]: ListTypeNameEnum.sale,
  [ListTypeEnum.news]: ListTypeNameEnum.news,
  [ListTypeEnum.up]: ListTypeNameEnum.up,
}

export interface ListType {
  sale: string
  news: string
  up: string
}

export interface CategoryItemType {
  key: number
  id?: number
  title: string
}

export type SelectItemProps<T = any> = {
  id: T
  timeRange: any
}

export enum TimeTypeEnum {
  hour24 = 1,
  day7 = 2,
}

export interface ListItemConfig {
  topBgImg: string
}

export interface ListReqType {
  countryCode: string
  currencyCode: string
  language: string
  // 1:飙升榜;2:销量榜;3:新品榜
  listType: ListTypeEnum
  // 1:过去24多小时;2:近7天
  timeType: TimeTypeEnum
}

export interface ProductItemType {
  /**
   * 主图
   */
  spuLogoUrl?: string
  /**
   * 热值
   */
  topIndex?: string
  /**
   * 最低价
   */
  price?: number
  /**
   * 热值前缀
   */
  topIndexDes?: string
  /**
   * 尺码
   */
  spuSize?: string
  /**
   * skuId
   */
  skuId?: number
  /**
   * spuId
   */
  spuId?: number
  /**
   * 名字
   */
  spuName?: string
  /**
   * 是否缺货
   */
  breakCode?: boolean
  /**
   * 跳转客户端的tab
   */
  breakCodeTag?: number
}

export interface ListResType {
  /**
   * 正确响应时该值为 Result#SUCCESS_CODE，错误响应时为错误代码
   */
  code?: number
  /**
   * 正确响应时该值会被使用
   */
  data: {
    spuList: ProductItemType[]
    moreTopList: any[]
  }
  /**
   * 正确响应时该值为 Result#DEFAULT_SUCCESS_MESSAGE，错误响应时为错误信息
   */
  msg?: string
  status: number
}
